import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Slide from "@mui/material/Slide";
import dateFormat from "dateformat";
import moment from "moment";
import TextField from "@mui/material/TextField";
import FormLabel from "@mui/material/FormLabel";
import FormGroup from "@mui/material/FormGroup";
import InfoIcon from "@mui/icons-material/Info";
import IconButton from "@mui/material/IconButton";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import {
  Avatar,
  Box,
  Card,
  CardHeader,
  CardContent,
  Checkbox,
  Divider,
  Grid,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Button,
  Chip,
} from "@mui/material";
import Brightness1Icon from "@mui/icons-material/Brightness1";
import Marquee from "react-fast-marquee";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { makeStyles } from "@material-ui/core/styles";
import PlanA from "./PlanA";
import Payment from "./Payment";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "40px"
  },
  container: {
    display: "flex"
  },
  item: {
    // border: "1px solid blue",
    flexBasis: "33%",
    // maxWidth: "33%",
    maxWidth: "50%",
    marginLeft: "20px"
  },
  itemFlexGrow: {
    flexGrow: 0,
    border: "1px solid red"
  },
  root1: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  chip: {
    margin: theme.spacing(0.5),
  },
  section1: {
    margin: theme.spacing(3, 2),
  },
  section2: {
    margin: theme.spacing(2),
  },
  section3: {
    margin: theme.spacing(3, 1, 1),
  },  
}));

export default function LICENSE() {
  const classes = useStyles();
  const [licenseinfo, setLicenseinfo] = useState([]);

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_URL}/api/licensestatus/`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + window.localStorage.getItem("token"),
        },
      }
    )
      .then((resp) => resp.json())
      .then((resp) => setLicenseinfo(resp))
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);  
  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
        <Card>
          <CardHeader 
          title="LICENSE" 
          action={
            <React.Fragment>
      <div className={classes.section3}>
        {/* <Button variant="contained" color="primary">Buy Now</Button> */}
        <Payment />
      </div>      
            </React.Fragment>
          }          
          />
          <Paper sx={{ width: "100%" }}>
          <TableContainer sx={{ maxHeight: 1050, height: 100 }}>
          <div className={classes.root}>
      <div className={classes.container}>
        <div className={classes.item}>Audit Executions Limit:{" "}<strong>{licenseinfo.limit}</strong></div>
        <Divider orientation="vertical" flexItem />
        <div className={classes.item}>Total Audit Used:{" "}<strong>{licenseinfo.used}</strong></div>
        {/* <Divider orientation="vertical" flexItem /> */}
        {/* <div className={classes.item}>Expiration Date:{" "}<strong>JUL 2022</strong></div> */}
      </div>
    </div>
    </TableContainer>
          </Paper>
        </Card>
      </div>  
    </>
  );
}